import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Button from '../components/UI/Button';

const TermsOfUse: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 flex items-center">
          <Button 
            variant="ghost" 
            className="mr-4"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-3xl font-bold">Conditions Générales d'Utilisation</h1>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8 space-y-8">
          <section>
            <h2 className="text-xl font-semibold mb-4">1. Objet du service</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Notre application permet aux utilisateurs (freelances, auto-entrepreneurs, entreprises) de générer, 
              personnaliser et gérer des factures à l'aide de l'intelligence artificielle.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">2. Accès au service</h2>
            <p className="text-gray-600 dark:text-gray-400">
              L'accès au service est disponible en ligne via abonnement ou accès ponctuel. L'utilisateur doit 
              disposer d'une connexion Internet et d'un compte valide pour utiliser toutes les fonctionnalités.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">3. Responsabilités de l'utilisateur</h2>
            <p className="text-gray-600 dark:text-gray-400">
              L'utilisateur s'engage à fournir des informations exactes lors de l'utilisation du service et à 
              respecter les lois en vigueur en matière de facturation et de fiscalité. Nous ne sommes pas 
              responsables du contenu généré par l'utilisateur.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">4. Paiement et abonnement</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Certaines fonctionnalités sont payantes. Les paiements sont traités via un prestataire externe. 
              Aucun remboursement ne sera effectué sauf obligation légale. L'utilisateur peut annuler son 
              abonnement à tout moment.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">5. Propriété intellectuelle</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Tous les contenus, interfaces et modèles fournis restent la propriété exclusive de l'éditeur. 
              L'utilisateur conserve la propriété des données qu'il génère via la plateforme.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">6. Données personnelles</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Les données sont traitées conformément à notre politique de confidentialité. Aucune donnée n'est 
              vendue à des tiers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">7. Résiliation</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Nous nous réservons le droit de suspendre ou supprimer un compte en cas de non-respect des 
              présentes CGU ou d'utilisation abusive.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">8. Modifications</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Nous pouvons modifier ces conditions à tout moment. Les utilisateurs seront notifiés en cas de 
              changement majeur.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">9. Contact</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Pour toute question, merci de nous contacter à : contact@invoice-ai.fr
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;